import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaLanguage } from "react-icons/fa";
import useRequest from "./../api/useRequest";
import { UserSettingsRequestFactory } from "../api/requestFactory";
import languages from "../services/languages";

const LanguageSelected = () => {
  const { requestMaker } = useRequest();
  const [language, setLanguage] = useState("");
  useEffect(() => {
    requestMaker(UserSettingsRequestFactory.createGetUserSettingsRequest())
      .then((response) => {
        setLanguage(
          languages.find((lang) => lang.code === response.language).name
        );
      })
      .catch((err) => {
        console.error(err);
      });
  }, [requestMaker]);

  return (
    <div className="flex items-center">
      <div className="mr-2">
        <Link
          to="/workspace/ai-settings"
          state={{ tab: "language" }}
          className="text-blue-500 ml-2 hover:text-blue-700"
        >
          <FaLanguage className="inline-block mr-1 icon-language" size={30} />{" "}
          {language}
        </Link>
      </div>
    </div>
  );
};

export default LanguageSelected;
